import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=3819ba38&scoped=true"
import script from "./Retail.vue?vue&type=script&lang=js"
export * from "./Retail.vue?vue&type=script&lang=js"
import style0 from "./Retail.vue?vue&type=style&index=0&id=3819ba38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819ba38",
  null
  
)

export default component.exports